import { api, publicApi } from '../lib/api'

export type CreatorSubscriptionSettings = {
  is_enabled: boolean
  monthly_price_pixe: number | null
  currency: 'PIXE' | 'USD'
  allow_pay_per_view: boolean
  default_ppv_price_pixe: number | null
  enable_subscriber_comments: boolean
  enable_early_access: boolean
  enable_subscriber_badge: boolean
  enable_polls: boolean
  enable_bts_pixies: boolean
  pitch_text?: string
  created_at?: string
  updated_at?: string
}

export type CreatorTier = {
  id: number
  name: string
  rank: 1 | 2 | 3
  monthly_price_pixe: number
  is_active: boolean
  created_at?: string
  updated_at?: string
}

export async function getMyCreatorSubscriptionSettings() {
  const { data } = await api.get<CreatorSubscriptionSettings>('/api/creator/subscriptions/settings/')
  return data
}

export async function patchMyCreatorSubscriptionSettings(patch: Partial<CreatorSubscriptionSettings>) {
  const { data } = await api.patch<CreatorSubscriptionSettings>('/api/creator/subscriptions/settings/', patch)
  return data
}

export async function listMyCreatorTiers() {
  const { data } = await api.get<{ results: CreatorTier[] }>('/api/creator/subscriptions/tiers/')
  return data
}

export async function createMyCreatorTier(payload: Pick<CreatorTier, 'name' | 'rank' | 'monthly_price_pixe' | 'is_active'>) {
  const { data } = await api.post<CreatorTier>('/api/creator/subscriptions/tiers/', payload)
  return data
}

export async function patchMyCreatorTier(tierId: number, patch: Partial<Pick<CreatorTier, 'name' | 'rank' | 'monthly_price_pixe' | 'is_active'>>) {
  const { data } = await api.patch<CreatorTier>(`/api/creator/subscriptions/tiers/${tierId}/`, patch)
  return data
}

export async function deleteMyCreatorTier(tierId: number) {
  const { data } = await api.delete<{ ok: boolean }>(`/api/creator/subscriptions/tiers/${tierId}/`)
  return data
}

export type CreatorSubscriptionSettingsPublic = {
  creator_id: number
  is_enabled: boolean
  monthly_price_pixe: number | null
  currency: 'PIXE' | 'USD'
  allow_pay_per_view: boolean
  default_ppv_price_pixe: number | null
  pitch_text?: string
  subscription_benefits?: string[]
  subscription_subscriber_count?: number
  subscription_recent_posts?: Array<{
    id: number
    title: string
    published_at: string
    snippet: string
    cover_image_url?: string
    url: string
  }>
  viewer_is_subscribed?: boolean
  viewer_subscription_started_at?: string | null
  viewer_subscription_renews_at?: string | null
  viewer_subscription_plan_label?: string | null
  tiers?: CreatorTier[]
  features?: Record<string, boolean>
}

export async function getCreatorSubscriptionSettingsPublic(creatorId: number) {
  const { data } = await publicApi.get<CreatorSubscriptionSettingsPublic>(`/api/subscriptions/creators/${creatorId}/`)
  return data
}
